import { Component, Input, Output } from '@angular/core';
import { BaseStepComponent } from '../../base';
import { TipoDecisao } from 'app/entity/enumeraveis';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'decisao-de-julgamento',
    templateUrl: './decisao-de-julgamento.html'
})
export class DecisaoDeJulgamentoComponent extends BaseStepComponent {
    @Input() etapa: number;
    @Input() listaPntCRC: any[];
    @Input() decisaoComissaoCrc: any;
    @Input() habilitaCamposPontuacao: boolean;
    @Input() disabledCheckbox: boolean;

    replicarPontuacao(event: any) {
        const pontuacoesEmHomologacao = this.cadastro.get('pontuacao_homologacao_atividade').value;

        pontuacoesEmHomologacao.forEach(element => {
            element.valor = event ? this.listaPntCRC.find(x => x.name === element.label).values[0] : 0;
        });

        this.cadastro.get('pontuacao_homologacao_atividade').setValue(pontuacoesEmHomologacao);
    }
}




// WEBPACK FOOTER //
// ./src/app/Componentes/decisao-de-julgamento/decisao-de-julgamento.ts